/**
 * Dynamic PWA Manifest Injector
 * 
 * Updates the manifest link to point to the API endpoint
 * that serves store-specific manifest.json
 * 
 * Note: Skips injection in development to avoid cross-origin issues
 */

import { baseUrl } from '../config/constants';

const isProduction = process.env.NODE_ENV === 'production';

export function injectDynamicManifest() {
    // Skip in development - manifest must be same-origin
    // In development: localhost:19006 vs localhost:3000 = different origins
    if (!isProduction) {
        return;
    }

    // Remove existing static manifest link
    const existingLink = document.querySelector('link[rel="manifest"]');
    if (existingLink) {
        existingLink.remove();
    }

    // In production (Cloudflare Pages), use relative URL to avoid CORS
    // Cloudflare will handle routing /manifest/* to the API
    const manifestUrl = '/api/manifest/manifest.json';

    // Create and inject new manifest link
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = manifestUrl;
    document.head.appendChild(link);
}
